var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6672 3.85737L13.0798 10.4448L19.6672 17.0322C20.3918 17.7568 20.3918 18.9426 19.6672 19.6672C18.9426 20.3918 17.7568 20.3918 17.0322 19.6672L10.4448 13.0798L3.85737 19.6672C3.13275 20.3918 1.94701 20.3918 1.2224 19.6672C0.49778 18.9426 0.497779 17.7568 1.2224 17.0322L7.80982 10.4448L1.2224 3.85737C0.497779 3.13275 0.49778 1.94701 1.2224 1.2224C1.94701 0.49778 3.13275 0.497781 3.85737 1.2224L10.4448 7.80982L17.0322 1.2224C17.7568 0.49778 18.9426 0.49778 19.6672 1.2224C20.3918 1.94701 20.3918 3.13275 19.6672 3.85737Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d9c06844bf141b5661fca04481763228.svg";
export { ForwardRef as ReactComponent };